/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Response model for resuming a Persona inquiry.
 */
export interface ResumeInquiryResponse {
  inquiry_id: string;
  session_token: string;
}
